export const initialState = {
    currentposts: [],
    search: "",
    liked: [], 
    bookmarked: [],
    createAPost: "", 
    bookmarks: [], 
    users: [], 
    following: [],
    updatedUser: "", 
    toFollow: [], 
    user: [],
    postDetails: "", 
    usersPost: []
}